import holeDetectionRouter from './HolesRouter';

export default holeDetectionRouter;
